/**
 * decode html entities and strip html tags from text
 * useful for cleaning form field labels that may contain html entities or tags
 * 
 * @param {string} text - text that may contain html entities or tags
 * @returns {string} - clean text without html entities or tags
 * 
 * @example
 * cleanLabel('Trade name&nbsp;') // returns 'Trade name'
 * cleanLabel('<span style="color: rgb(55, 65, 81);">Enter Description</span>') // returns 'Enter Description'
 */
export const cleanLabel = (text) => {
  if (!text) return text;
  
  // decode html entities using textarea element
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  const decoded = textarea.value;
  
  // strip html tags using div element
  const temp = document.createElement('div');
  temp.innerHTML = decoded;
  
  return (temp.textContent || temp.innerText || '').trim();
};

